import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-cancel-confirm-modal',
  templateUrl: './cancel-confirm-modal.component.html',
  styleUrls: ['./cancel-confirm-modal.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class CancelConfirmModalComponent implements OnInit {

  @Input() message: string = '';
  @Input() cancelButtonText: string = '';
  @Input() acceptButtonText: string = '';

  constructor(public activeModal: NgbActiveModal) {}

  ngOnInit(): void {
  }

}
